import api from './api';

export const getTasks = async (type) => {
  try {
    const response = await api({
      method: 'GET',
      url: '/tasks',
      params: {
        labels: type,
      },
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};
